export function runtimeApiBase(): string {
  return `${window.location.protocol}//${window.location.host}/api/v1`
}
